// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__33vdZ","small-icon":"styles_small-icon__3onSg"};